<mat-card class="col-sm-12">
  <mat-tab-group (selectedIndexChange)="reloadTabData($event)" >


    <!-- Tab 1 -->
    <mat-tab label="System Templates Logs" >
      <mat-card-content>
        <div class="col-sm-12 text-center">
          <ul class="nav nav-tabs" style="margin-top: 10px;">
            <li class="nav-item"><a (click)="clearTemplateLogs();getTemplateLogs();"
              class="nav-link active" style="cursor: pointer;background-color: gainsboro;">Refresh</a></li>
            <hr>
          </ul>
          <div>
            <div>
              <mat-form-field class="col-sm-12">
                <mat-label>Filter</mat-label>
                <input matInput (keyup)="applyFilterTemplateLogs($event)" placeholder="Filter value">
              </mat-form-field>
            </div>

            <table mat-table [dataSource]="templateLogsTableData" class="col-sm-12 mat-elevation-z8"
              style="background-color: whitesmoke;" matSort>

              <ng-container matColumnDef="job_id">
                <th mat-header-cell *matHeaderCellDef class="px-2" mat-sort-header> Job ID </th>
                <td mat-cell *matCellDef="let element" class="px-2"> {{element.job_id?element.job_id:"NA"}} </td>
              </ng-container>

              <ng-container matColumnDef="job_name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Job Name </th>
                <td mat-cell *matCellDef="let element"> {{element.job_name?element.job_name:"NA"}} </td>
              </ng-container>

              <ng-container matColumnDef="ip_address">
                <th mat-header-cell *matHeaderCellDef mat-sort-header style="justify-content: center;"> Unit IP Address</th>
                <td mat-cell *matCellDef="let element"> {{element.ip_address?element.ip_address:"NA"}} </td>
              </ng-container>

              <ng-container matColumnDef="created_at">
                <th mat-header-cell *matHeaderCellDef mat-sort-header style="justify-content: center;"> Job Creation Date</th>
                <td mat-cell *matCellDef="let element"> {{element.created_at?element.created_at:"NA"}} </td>
              </ng-container>

              <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let element">
                  <button mat-stroked-button color="primary"
                  (click)="sendIDToDialog(element.job_id,element.ip_address)">
                  Show Details
                </button>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="templateLogsColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: templateLogsColumns;"></tr>
            </table>

            <mat-paginator [length]='templateLogs.length' [pageSize]='10' [pageSizeOptions]="[5, 10, 20]"
              showFirstLastButtons>
            </mat-paginator>
          </div>
        </div>
      </mat-card-content>
    </mat-tab>
    <!-- End Tab 1 -->


    <!-- Tab 2 -->
    <mat-tab label="Software Upgrades Logs">
      <mat-card-content >
        <div class="col-sm-12 text-center">
          <ul class="nav nav-tabs" style="margin-top: 10px;">
            <li class="nav-item"><a (click)="clearSoftwareUpgradeLogs();getSoftwareUpgradeLogs();"
              class="nav-link active" style="cursor: pointer;background-color: gainsboro;">Refresh</a></li>
            <hr>
          </ul>
          <div>
            <div>
              <mat-form-field class="col-sm-12">
                <mat-label>Filter</mat-label>
                <input matInput (keyup)="applyFilterSoftwareUpgradeLogs($event)" placeholder="Filter value">
              </mat-form-field>
            </div>

            <table mat-table [dataSource]="softwareUpgradeLogsTableData" class="col-sm-12 mat-elevation-z8"
              style="background-color: whitesmoke;" matSort>

              <ng-container matColumnDef="job_id">
                <th mat-header-cell *matHeaderCellDef class="px-2" mat-sort-header> Job ID </th>
                <td mat-cell *matCellDef="let element" class="px-2"> {{element.job_id?element.job_id:"NA"}} </td>
              </ng-container>

              <ng-container matColumnDef="system_name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> System Name </th>
                <td mat-cell *matCellDef="let element"> {{element.system_name?element.system_name:"NA"}} </td>
              </ng-container>

              <ng-container matColumnDef="system_ip">
                <th mat-header-cell *matHeaderCellDef mat-sort-header style="justify-content: center;"> Unit IP Address</th>
                <td mat-cell *matCellDef="let element"> {{element.system_ip?element.system_ip:"NA"}} </td>
              </ng-container>

              <ng-container matColumnDef="created_at">
                <th mat-header-cell *matHeaderCellDef mat-sort-header style="justify-content: center;"> Job Creation Date</th>
                <td mat-cell *matCellDef="let element"> {{element.created_at?element.created_at:"NA"}} </td>
              </ng-container>

              <ng-container matColumnDef="job_status">
                <th mat-header-cell *matHeaderCellDef mat-sort-header style="justify-content: center;"> Job Status</th>
                <td mat-cell *matCellDef="let element"> {{element.job_status?element.job_status:"NA"}} </td>
              </ng-container>

              <ng-container matColumnDef="start_at">
                <th mat-header-cell *matHeaderCellDef mat-sort-header style="justify-content: center;"> Job Start Date</th>
                <td mat-cell *matCellDef="let element"> {{element.start_at?element.start_at:"NA"}} </td>
              </ng-container>

              <ng-container matColumnDef="parent_job_id">
                <th mat-header-cell *matHeaderCellDef mat-sort-header style="justify-content: center;"> Job Parent ID</th>
                <td mat-cell *matCellDef="let element"> {{element.parent_job_id?element.parent_job_id:"NA"}} </td>
              </ng-container>

              <ng-container matColumnDef="upgrade_status_last_change">
                <th mat-header-cell *matHeaderCellDef mat-sort-header style="justify-content: center;"> Upgrade Status Last Change</th>
                <td mat-cell *matCellDef="let element"> {{element.upgrade_status_last_change?element.upgrade_status_last_change:"NA"}} </td>
              </ng-container>

              <ng-container matColumnDef="upgrade_status_status">
                <th mat-header-cell *matHeaderCellDef mat-sort-header style="justify-content: center;">Upgrade Status</th>
                <td mat-cell *matCellDef="let element"> {{element.upgrade_status_status?element.upgrade_status_status:"NA"}} </td>
              </ng-container>

              <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef> </th>
                <td mat-cell *matCellDef="let element">
                  <button mat-stroked-button color="primary"
                  (click)="sendIDToDialog(element.job_id,element.system_ip)">
                  Show Details
                </button>
                </td>
              </ng-container>


              <tr mat-header-row *matHeaderRowDef="softwareUpgradeLogsColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: softwareUpgradeLogsColumns;"></tr>
            </table>

            <mat-paginator [length]='softwareUpgradeLogs.length' [pageSize]='10' [pageSizeOptions]="[5, 10, 20]"
              showFirstLastButtons>
            </mat-paginator>
          </div>

        </div>
      </mat-card-content>
    </mat-tab>
    <!-- End Tab 2 -->


    <!-- Tab 3 -->
    <mat-tab label="Configurations Templates Logs">
      <mat-card-content >
        <div class="col-sm-12 text-center">
          <ul class="nav nav-tabs" style="margin-top: 10px;">
            <li class="nav-item"><a (click)="clearUpcomingTemplatesLogs();getUpcomingTemplatesLogs();"
              class="nav-link active" style="cursor: pointer;background-color: gainsboro;">Refresh</a></li>
            <hr>
          </ul>
          <div>
            <div>
              <mat-form-field class="col-sm-12">
                <mat-label>Filter</mat-label>
                <input matInput (keyup)="applyFilterUpcomingTemplatesLogs($event)" placeholder="Filter value">
              </mat-form-field>
            </div>

            <table mat-table [dataSource]="upcomingTemplatesLogsTableData" class="col-sm-12 mat-elevation-z8"
              style="background-color: whitesmoke;" matSort>

              <ng-container matColumnDef="job_title">
                <th mat-header-cell *matHeaderCellDef class="px-2" mat-sort-header> Job Title </th>
                <td mat-cell *matCellDef="let element" class="px-2" [style.background-color]="element.expired=='Yes'?'darkseagreen':'White'"> {{element.job_title?element.job_title:"NA"}} </td>
              </ng-container>

              <ng-container matColumnDef="template_job_id">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Job ID </th>
                <td mat-cell *matCellDef="let element" [style.background-color]="element.expired=='Yes'?'darkseagreen':'White'"> {{element.template_job_id?element.template_job_id:"NA"}} </td>
              </ng-container>

              <ng-container matColumnDef="start_job_at">
                <th mat-header-cell *matHeaderCellDef mat-sort-header style="justify-content: center;">Start Date</th>
                <td mat-cell *matCellDef="let element" [style.background-color]="element.expired=='Yes'?'darkseagreen':'White'"> {{element.start_job_at?element.start_job_at:"NA"}} </td>
              </ng-container>

              <ng-container matColumnDef="next_run_time">
                <th mat-header-cell *matHeaderCellDef mat-sort-header style="justify-content: center;">Next Run Time</th>
                <td mat-cell *matCellDef="let element" [style.background-color]="element.expired=='Yes'?'darkseagreen':'White'"> {{element.next_run_time?element.next_run_time:"NA"}} </td>
              </ng-container>

              <ng-container matColumnDef="expired">
                <th mat-header-cell *matHeaderCellDef mat-sort-header style="justify-content: center;">Job Expired</th>
                <td mat-cell *matCellDef="let element" [style.background-color]="element.expired=='Yes'?'darkseagreen':'White'"> {{element.expired}} </td>
              </ng-container>

              <ng-container matColumnDef="template_frequency">
                <th mat-header-cell *matHeaderCellDef mat-sort-header style="justify-content: center;">Template Frequency</th>
                <td mat-cell *matCellDef="let element" [style.background-color]="element.expired=='Yes'?'darkseagreen':'White'"> {{element.template_frequency?element.template_frequency:"NA"}} </td>
              </ng-container>

              <ng-container matColumnDef="job_creator_editor">
                <th mat-header-cell *matHeaderCellDef mat-sort-header style="justify-content: center;">Created by</th>
                <td mat-cell *matCellDef="let element" [style.background-color]="element.expired=='Yes'?'darkseagreen':'White'"> {{element.job_creator_editor?element.job_creator_editor:"NA"}} </td>
              </ng-container>

              <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef> </th>
                <td mat-cell *matCellDef="let element" >
                  <button mat-stroked-button color="primary"
                  (click)="sendTemplateIDToDialog(element.template_job_id)">
                  Show Details
                </button>
                </td>
              </ng-container>


              <tr mat-header-row *matHeaderRowDef="upcomingTemplatesLogsColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: upcomingTemplatesLogsColumns;"></tr>
            </table>

            <mat-paginator [length]='upcomingTemplatesLogs.length' [pageSize]='10' [pageSizeOptions]="[5, 10, 20]"
              showFirstLastButtons>
            </mat-paginator>
          </div>

        </div>
      </mat-card-content>
    </mat-tab>
    <!-- End Tab 3 -->


     <!-- Tab 4 -->
     <mat-tab label="Upcoming Software Upgrades">
      <mat-card-content >
        <div class="col-sm-12 text-center">
          <ul class="nav nav-tabs" style="margin-top: 10px;">
            <li class="nav-item"><a (click)="clearUpcomingSoftwareUpgradesLogs();getUpComingSoftwareUpgrades();"
              class="nav-link active" style="cursor: pointer;background-color: gainsboro;">Refresh</a></li>
            <hr>
          </ul>
          <div>
            <div>
              <mat-form-field class="col-sm-12">
                <mat-label>Filter</mat-label>
                <input matInput (keyup)="applyFilterUpcomingSoftwareUpgradesLogs($event)" placeholder="Filter value">
              </mat-form-field>
            </div>

            <table mat-table [dataSource]="upComingSoftwareUpgradesTableData" class="col-sm-12 mat-elevation-z8"
              style="background-color: whitesmoke;" matSort>

              <ng-container matColumnDef="deleteIcon">
                <th mat-header-cell *matHeaderCellDef class="px-2" mat-sort-header> </th>
                <td mat-cell *matCellDef="let element;" style="width: 1vw;">
                  <div style="display: inline-block;">
                    <mat-icon aria-hidden="false" aria-label="delete_forever" matTooltip="Remove"
                      class="deleteSingleRow"
                      (click)="openDialogRemoveSWUpgrade(element)" style="color: red;cursor: pointer;">
                      delete_forever
                    </mat-icon>
                  </div>
              </td>
            </ng-container>

              <ng-container matColumnDef="job_id">
                <th mat-header-cell *matHeaderCellDef class="px-2" mat-sort-header> Job ID </th>
                <td mat-cell *matCellDef="let element" class="px-2"> {{element.job_id?element.job_id:"NA"}} </td>
              </ng-container>

              <ng-container matColumnDef="system_ip">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Unit IP Address </th>
                <td mat-cell *matCellDef="let element"> {{element.system_ip?element.system_ip:"NA"}} </td>
              </ng-container>

              <ng-container matColumnDef="operation_name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header style="justify-content: center;"> Operation Name</th>
                <td mat-cell *matCellDef="let element"> {{element.operation_name?element.operation_name:"NA"}} </td>
              </ng-container>

              <ng-container matColumnDef="start_at">
                <th mat-header-cell *matHeaderCellDef mat-sort-header style="justify-content: center;">Upgrade Date</th>
                <td mat-cell *matCellDef="let element"> {{element.start_at?element.start_at:"NA"}} </td>
              </ng-container>

              <ng-container matColumnDef="system_command">
                <th mat-header-cell *matHeaderCellDef mat-sort-header style="justify-content: center;">System Command</th>
                <td mat-cell *matCellDef="let element"> {{element.system_command?element.system_command:"NA"}} </td>
              </ng-container>


              <tr mat-header-row *matHeaderRowDef="upComingSoftwareUpgrades"></tr>
              <tr mat-row *matRowDef="let row; columns: upComingSoftwareUpgrades;"></tr>
            </table>

            <mat-paginator [length]='upComingSoftwareUpgradesLogs.length' [pageSize]='10' [pageSizeOptions]="[5, 10, 20]"
              showFirstLastButtons>
            </mat-paginator>
          </div>

        </div>
      </mat-card-content>
    </mat-tab>
    <!-- End Tab 4 -->

   <!-- Tab 5 -->
   <mat-tab label="System Conflicts Logs" >
    <mat-card-content>
      <div class="col-sm-12 text-center">
        <ul class="nav nav-tabs" style="margin-top: 10px;">
          <li class="nav-item"><a (click)="clearConflictsLogs();getConflictLogs();"
            class="nav-link active" style="cursor: pointer;background-color: gainsboro;">Refresh</a></li>
          <hr>
        </ul>
        <div>
          <div>
            <mat-form-field class="col-sm-12">
              <mat-label>Filter</mat-label>
              <input matInput (keyup)="applyFilterConflictsLogs($event)" placeholder="Filter value">
            </mat-form-field>
          </div>

          <table mat-table [dataSource]="conflictsTableData" class="col-sm-12 mat-elevation-z8"
            style="background-color: whitesmoke;" matSort>

            <ng-container matColumnDef="conflict_date">
              <th mat-header-cell *matHeaderCellDef class="px-2" mat-sort-header> Date </th>
              <td mat-cell *matCellDef="let element" class="px-2"> {{element.conflict_date?element.conflict_date:"NA"}} </td>
            </ng-container>

            <ng-container matColumnDef="conflict_ip">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> Conflict IP </th>
              <td mat-cell *matCellDef="let element"> {{element.conflict_ip?element.conflict_ip:"NA"}} </td>
            </ng-container>

            <ng-container matColumnDef="affected_ip">
              <th mat-header-cell *matHeaderCellDef mat-sort-header > Affected IP</th>
              <td mat-cell *matCellDef="let element"> {{element.affected_ip?element.affected_ip:"NA"}} </td>
            </ng-container>

            <ng-container matColumnDef="issue">
              <th mat-header-cell *matHeaderCellDef mat-sort-header style="justify-content: center;"> Issue Description</th>
              <td mat-cell *matCellDef="let element" style="word-wrap: anywhere;" > {{element.issue?element.issue:"NA"}} </td>
            </ng-container>

            <ng-container matColumnDef="action_taken">
              <th mat-header-cell *matHeaderCellDef mat-sort-header style="justify-content: center;"> Action Taken</th>
              <td mat-cell *matCellDef="let element" style="word-wrap: anywhere;" > {{element.action_taken?element.action_taken:"NA"}} </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="conflictsColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: conflictsColumns;"></tr>
          </table>

          <mat-paginator [length]='conflictsLogs.length' [pageSize]='10' [pageSizeOptions]="[5, 10, 20]"
            showFirstLastButtons>
          </mat-paginator>
        </div>
      </div>
    </mat-card-content>
  </mat-tab>
  <!-- End Tab 5-->

  <!-- Tab 6 -->
  <mat-tab label="Audit Logs" >
  <mat-card-content>
    <div class="col-sm-12 text-center">
      <ul class="nav nav-tabs" style="margin-top: 10px;">
        <li class="nav-item"><a (click)="clearAuditLogs();getAuditLogs();"
          class="nav-link active" style="cursor: pointer;background-color: gainsboro;">Refresh</a></li>
        <hr>
      </ul>
      <div>
        <div>
          <mat-form-field class="col-sm-12">
            <mat-label>Filter</mat-label>
            <input matInput (keyup)="applyFilterAuditLogs($event)" placeholder="Filter value">
          </mat-form-field>
        </div>

        <table mat-table [dataSource]="auditTableData" class="col-sm-12 mat-elevation-z8"
          style="background-color: whitesmoke;" matSort>

          <ng-container matColumnDef="request_details">
            <th mat-header-cell *matHeaderCellDef class="px-2" mat-sort-header> Request Details </th>
            <td mat-cell *matCellDef="let element" class="px-2"> {{element.request_details?element.request_details:"NA"}} </td>
          </ng-container>

          <ng-container matColumnDef="requested_by">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Requested By </th>
            <td mat-cell *matCellDef="let element"> {{element.requested_by?element.requested_by:"NA"}} </td>
          </ng-container>

          <ng-container matColumnDef="requested_at">
            <th mat-header-cell *matHeaderCellDef mat-sort-header > Requested At</th>
            <td mat-cell *matCellDef="let element"> {{element.requested_at?element.requested_at:"NA"}} </td>
          </ng-container>

          <ng-container matColumnDef="request_state">
            <th mat-header-cell *matHeaderCellDef mat-sort-header style="justify-content: center;">Request State</th>
            <td mat-cell *matCellDef="let element" style="word-wrap: anywhere;" > {{element.request_state?element.request_state:"NA"}} </td>
          </ng-container>

          <ng-container matColumnDef="completed_at">
            <th mat-header-cell *matHeaderCellDef mat-sort-header style="justify-content: center;"> Completion Date</th>
            <td mat-cell *matCellDef="let element" style="word-wrap: anywhere;" > {{element.completed_at?element.completed_at:"NA"}} </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="auditColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: auditColumns;"></tr>
        </table>

        <mat-paginator [length]='conflictsLogs.length' [pageSize]='10' [pageSizeOptions]="[5, 10, 20]"
          showFirstLastButtons>
        </mat-paginator>
      </div>
    </div>
  </mat-card-content>
</mat-tab>
<!-- End Tab 6 -->

    <!-- Tab 7 -->
    <mat-tab label="Wallpaper Push Logs" >
      <mat-card-content>
        <div class="col-sm-12 text-center">
          <ul class="nav nav-tabs" style="margin-top: 10px;">
            <li class="nav-item"><a (click)="clearWallpaperLogs();getWallpaperLogs();"
              class="nav-link active" style="cursor: pointer;background-color: gainsboro;">Refresh</a></li>
            <hr>
          </ul>
          <div>
            <div>
              <mat-form-field class="col-sm-12">
                <mat-label>Filter</mat-label>
                <input matInput (keyup)="applyFilterWallpaperLogs($event)" placeholder="Filter value">
              </mat-form-field>
            </div>

            <table mat-table [dataSource]="wallpaperTableData" class="col-sm-12 mat-elevation-z8"
              style="background-color: whitesmoke;" matSort>

              <ng-container matColumnDef="job_id">
                <th mat-header-cell *matHeaderCellDef class="px-2" mat-sort-header> Job ID </th>
                <td mat-cell *matCellDef="let element" class="px-2"> {{element.job_id?element.job_id:"NA"}} </td>
              </ng-container>

              <ng-container matColumnDef="endpoint_ip">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Unit IP Address </th>
                <td mat-cell *matCellDef="let element"> {{element.endpoint_ip?element.endpoint_ip:"NA"}} </td>
              </ng-container>

              <ng-container matColumnDef="image_id">
                <th mat-header-cell *matHeaderCellDef mat-sort-header style="justify-content: center;"> Image Name</th>
                <td mat-cell *matCellDef="let element"> {{element.image_id?element.image_id:"NA"}} </td>
              </ng-container>

              <ng-container matColumnDef="created_by">
                <th mat-header-cell *matHeaderCellDef mat-sort-header style="justify-content: center;">Requested By</th>
                <td mat-cell *matCellDef="let element"> {{element.created_by?element.created_by:"NA"}} </td>
              </ng-container>

              <ng-container matColumnDef="creationDate">
                <th mat-header-cell *matHeaderCellDef mat-sort-header style="justify-content: center;">Creation Date</th>
                <td mat-cell *matCellDef="let element"> {{element.creationDate?element.creationDate:"NA"}} </td>
              </ng-container>

              <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let element">
                  <button mat-stroked-button color="primary"
                  (click)="sendIDToStateDialog(element.job_id)">
                  Show State
                </button>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="wallpaperColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: wallpaperColumns;"></tr>
            </table>

            <mat-paginator [length]='wallpaperLogs.length' [pageSize]='10' [pageSizeOptions]="[5, 10, 20]"
              showFirstLastButtons>
            </mat-paginator>
          </div>
        </div>
      </mat-card-content>
    </mat-tab>
    <!-- End Tab 7 -->

  </mat-tab-group>
</mat-card>


